<template>
  <div class="dict-page">
    <div class="types">
      <div class="types-hd">
        <span>字典类型</span>
      </div>
      <div
        v-for="t in types"
        :key="t.dictType"
        class="type-item"
        :class="{ active: currentType === t.dictType }"
        @click="selectType(t.dictType)"
      >
        <div class="name">{{ t.dictTypeName || t.dictType }}</div>
        <div class="meta">{{ t.dictType }} · {{ t.count }} 项</div>
      </div>
    </div>

    <div class="items">
      <div class="toolbar toolbar-between">
        <span class="title">{{ currentTypeName }}字典项</span>
        <el-button type="primary" icon="el-icon-plus" :disabled="!currentType" @click="openEdit()">新增</el-button>
      </div>
      <el-table :data="pageList" border v-loading="loading">
        <el-table-column prop="sortNo" label="排序" width="80" />
        <el-table-column prop="dictLabel" label="选项名称" min-width="140" />
        <el-table-column prop="dictValue" label="编码" min-width="140" />
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <list-pagination
        :total="listTotal"
        :page="page"
        :page-size="pageSize"
        @current-change="onPageChange"
        @size-change="onPageSizeChange"
      />

      <p v-if="currentType==='WORKER_TYPE'" class="tip">工种在此维护后，可用于「工人管理」「工人价格表」。</p>
      <p v-if="currentType==='MATERIAL_UNIT'" class="tip">材料单位在此维护后，可用于「材料管理」新增/编辑时的单位下拉。</p>
      <p v-if="currentType==='LABOR_APPLY_TYPE'" class="tip">工资类型用于「工资申请」。</p>
      <p v-if="currentType==='PROJECT_ITEM_TYPE'" class="tip">工序阶段用于工序/通知相关配置。</p>
    </div>

    <el-dialog :title="form.id?'编辑字典项':'新增字典项'" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="字典类型" required>
          <el-input v-model="form.dictType" disabled />
        </el-form-item>
        <el-form-item label="选项名称" required>
          <el-input v-model="form.dictLabel" placeholder="如：水电" />
        </el-form-item>
        <el-form-item label="编码">
          <el-input v-model="form.dictValue" placeholder="可选" />
        </el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sortNo" :min="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listDictTypes, listDicts, saveDict, deleteDict } from '../../api/dict'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'SysDict',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      types: [], currentType: 'WORKER_TYPE',
      list: [], loading: false, saving: false,
      visible: false, form: {}
    }
  },
  computed: {
    currentTypeName() {
      const t = this.types.find(x => x.dictType === this.currentType)
      return (t && (t.dictTypeName || t.dictType)) || this.currentType || ''
    }
  },
  created() {
    this.loadTypes()
  },
  methods: {
    async loadTypes() {
      const res = await listDictTypes()
      this.types = res.data || []
      if (!this.types.some(t => t.dictType === this.currentType) && this.types.length) {
        this.currentType = this.types[0].dictType
      }
      this.loadItems()
    },
    selectType(type) {
      this.currentType = type
      this.loadItems()
    },
    async loadItems() {
      if (!this.currentType) { this.list = []; this.page = 1; return }
      this.loading = true
      try {
        const res = await listDicts(this.currentType)
        this.list = res.data || []
        this.page = 1
      } finally { this.loading = false }
    },
    openEdit(row) {
      this.form = row
        ? { ...row }
        : { id: null, dictType: this.currentType, dictLabel: '', dictValue: '', sortNo: (this.list.length + 1) * 10, remark: '' }
      this.visible = true
    },
    async save() {
      const f = this.form
      if (!f.dictType || !f.dictLabel) return this.$message.warning('请填写选项名称')
      this.saving = true
      try {
        await saveDict(f)
        this.$message.success('已保存')
        this.visible = false
        this.currentType = f.dictType
        await this.loadTypes()
      } finally { this.saving = false }
    },
    onDelete(row) {
      this.$confirm(`确认删除「${row.dictLabel}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteDict(row.id)
          this.$message.success('已删除')
          this.loadTypes()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.dict-page { display:flex; gap:16px; min-height:420px; }
.types { width:220px; flex-shrink:0; border:1px solid #e2e8f0; border-radius:8px; background:#fff; }
.types-hd { display:flex; justify-content:space-between; align-items:center; padding:10px 12px; border-bottom:1px solid #e2e8f0; font-weight:600; }
.type-item { padding:10px 12px; cursor:pointer; border-bottom:1px solid #f1f5f9; }
.type-item:hover { background:#f8fafc; }
.type-item.active { background:#eff6ff; }
.type-item .name { font-size:14px; color:#0f172a; }
.type-item .meta { margin-top:4px; font-size:12px; color:#94a3b8; }
.items { flex:1; min-width:0; }
.toolbar .title { font-weight:600; }
.tip { margin-top:10px; font-size:12px; color:#94a3b8; }
</style>
